import { ReactComponent as IcArrowDown } from '../../../assets/icons/ic-arrow-down.svg';
import { ReactComponent as IcArrowLeft } from '../../../assets/icons/ic-arrow-left.svg';
import { ReactComponent as IcArrowRight } from '../../../assets/icons/ic-arrow-right.svg';
import { ReactComponent as IcDown } from '../../../assets/icons/ic-down.svg';
import { ReactComponent as IcPlay } from '../../../assets/icons/ic-play.svg';
import { ReactComponent as IcRefresh } from '../../../assets/icons/ic-refresh.svg';
import { ReactComponent as IcRotate } from '../../../assets/icons/ic-rotate.svg';
import { ReactComponent as IcSave } from '../../../assets/icons/ic-save.svg';
import { ReactComponent as IcStop } from '../../../assets/icons/ic-stop.svg';
import CatchuBlueSrc, {
  ReactComponent as CatchuBlue,
} from '../../../assets/image/catchu/blue.svg';
import CatchuGreenSrc, {
  ReactComponent as CatchuGreen,
} from '../../../assets/image/catchu/green.svg';
import CatchuOrangeSrc, {
  ReactComponent as CatchuOrange,
} from '../../../assets/image/catchu/orange.svg';
import CatchuPurpleSrc, {
  ReactComponent as CatchuPurple,
} from '../../../assets/image/catchu/purple.svg';
import CatchuSkyblueSrc, {
  ReactComponent as CatchuSkyblue,
} from '../../../assets/image/catchu/skyblue.svg';
import CatchuWhiteSrc, {
  ReactComponent as CatchuWhite,
} from '../../../assets/image/catchu/white.svg';
import CatchuYellowSrc, {
  ReactComponent as CatchuYellow,
} from '../../../assets/image/catchu/yellow.svg';
import CatchuYellowGreenSrc, {
  ReactComponent as CatchuYellowGreen,
} from '../../../assets/image/catchu/yellowgreen.svg';
import { ReactComponent as IcGameOver } from '../../../assets/image/game-over.svg';
import { ReactComponent as ImageCatchues } from '../../../assets/image/image-catchues.svg';
import { ReactComponent as ImageLogo } from '../../../assets/image/image-logo.svg';

const catchuBlueImage = new Image();
catchuBlueImage.src = CatchuBlueSrc;
const catchuGreenImage = new Image();
catchuGreenImage.src = CatchuGreenSrc;
const catchuOrangeImage = new Image();
catchuOrangeImage.src = CatchuOrangeSrc;
const catchuPurpleImage = new Image();
catchuPurpleImage.src = CatchuPurpleSrc;
const catchuSkyblueImage = new Image();
catchuSkyblueImage.src = CatchuSkyblueSrc;
const catchuWhiteImage = new Image();
catchuWhiteImage.src = CatchuWhiteSrc;
const catchuYellowImage = new Image();
catchuYellowImage.src = CatchuYellowSrc;
const catchuYellowGreenImage = new Image();
catchuYellowGreenImage.src = CatchuYellowGreenSrc;

export {
  CatchuBlue,
  CatchuGreen,
  CatchuOrange,
  CatchuPurple,
  CatchuSkyblue,
  CatchuWhite,
  CatchuYellow,
  CatchuYellowGreen,
  IcGameOver,
  IcPlay,
  IcRefresh,
  IcStop,
  IcArrowLeft,
  IcArrowRight,
  IcArrowDown,
  IcDown,
  IcRotate,
  IcSave,
  ImageCatchues,
  ImageLogo,
  catchuBlueImage,
  catchuGreenImage,
  catchuOrangeImage,
  catchuPurpleImage,
  catchuSkyblueImage,
  catchuWhiteImage,
  catchuYellowImage,
  catchuYellowGreenImage,
};
